module.exports = __webpack_public_path__ + "assets/img/falcon.f68eaab4.png";